<template>
    <div>
        <!-- 移动端卡片模式 -->
        <div v-if="cardMode" class="space-y-3">
            <!-- 格式转换按钮卡片 -->
            <div
                class="card bg-base-100 border border-base-200 hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
                <div class="card-body p-4">
                    <div for="change-format" class="flex items-center justify-between cursor-pointer" @click="formatMusicCheckBox = true">
                        <div class="flex items-center space-x-3">
                            <div class="p-2 bg-accent/10 rounded-lg">
                                <svg t="1704704621435" class="w-6 h-6 fill-accent" viewBox="0 0 1024 1024" version="1.1"
                                    xmlns="http://www.w3.org/2000/svg" p-id="3438">
                                    <path
                                        d="M136.192 986.112C66.56 986.112 10.24 927.744 10.24 856.576v-141.312c0-71.68 56.32-130.048 125.952-130.048h241.664c69.632 0 125.952 58.368 125.952 130.048v141.312c0 71.68-56.32 130.048-125.952 130.048H136.192z m0-325.12c-28.672 0-52.224 24.064-52.224 54.272v141.312c0 29.696 23.552 54.272 52.224 54.272h241.152c28.672 0 52.224-24.064 52.224-54.272v-141.312c0-29.696-23.552-54.272-52.224-54.272H136.192z m485.888 308.736c-19.968 0-31.232-15.872-31.744-31.232-0.512-14.848 8.192-32.768 35.84-35.328 26.112-4.608 46.08-8.704 70.144-16.896l1.024-0.512h1.024c9.216 0 40.448-22.528 66.56-53.76l0.512-1.024 1.536-1.024h0.512c14.336-7.168 38.912-48.64 51.712-96.256 0.512-3.072 1.024-5.632 1.536-8.192l0.512-2.56c3.072-16.896 6.144-31.744 6.144-49.152 0-2.048 0-5.12-0.512-10.24-0.512-3.072-0.512-5.632-0.512-8.704l-37.376 45.568c-9.728 10.752-18.944 12.8-25.088 12.8-4.096 0-8.704-1.024-12.8-3.072-9.728-5.12-15.36-11.776-17.408-20.48-2.56-11.264 3.584-21.504 6.144-25.088l0.512-0.512 84.992-105.472c3.072-3.072 20.48-19.456 38.912-19.456 26.112 0 40.448 23.04 44.032 29.184l76.288 110.08s12.288 17.408-9.216 39.936c-7.168 7.168-15.36 11.264-23.04 11.264-9.728 0-15.872-5.632-16.896-6.656l-42.496-56.832v16.896c0 60.928-20.48 119.808-60.928 175.104-40.448 50.688-86.528 83.456-140.8 101.376-2.048 1.024-5.12 2.048-13.312 4.096l-4.096 1.024c-12.288 3.072-23.552 5.12-33.28 6.656h-18.432z m-456.704-451.584c-28.672 0-43.008-26.624-44.544-30.208l-71.68-113.152s-12.288-17.408 9.216-39.424c7.68-7.168 15.36-11.264 23.04-11.264 9.728 0 15.872 5.632 16.896 6.656l42.496 56.32v-1.536-6.144c0.512-25.6 3.584-51.2 8.704-75.776 11.776-48.64 38.912-94.208 82.432-139.776 41.984-38.912 90.624-64 139.776-72.192 17.408-4.608 34.816-4.608 52.224-4.608 9.728 0 15.36 13.312 15.872 26.112 1.024 17.92-7.68 37.888-35.84 40.96l-2.048 0.512c-19.968 4.096-40.448 8.192-59.904 16.384-38.4 15.872-67.584 39.936-94.72 76.8l-4.608 6.656-2.048-1.536c-6.144 8.704-20.992 35.84-28.672 71.168l-0.512 3.072-0.512 1.536v0.512c-0.512 2.048-5.12 25.088-5.12 51.2v4.096c0 3.072 0.512 6.656 0.512 9.728 0 1.536 0 2.56 0.512 4.096l33.792-40.96c9.728-10.752 18.944-12.8 25.088-12.8 4.608 0 8.704 1.024 12.8 3.072 9.728 5.12 15.36 11.776 17.408 19.968 1.536 7.68-0.512 16.896-6.144 25.088v0.512L204.8 498.176c-3.584 3.584-20.992 19.968-39.424 19.968z m471.04-42.496c-69.632 0-125.952-58.368-125.952-130.048V204.8c0-71.68 56.32-130.048 125.952-130.048h241.152C947.2 74.752 1003.52 133.12 1003.52 204.8v141.312c0 71.68-56.32 130.048-125.952 130.048h-241.152z m0-325.12c-28.672 0-52.224 24.064-52.224 54.272v141.312c0 29.696 23.552 54.272 52.224 54.272h241.152c28.672 0 52.224-24.064 52.224-54.272V204.8c0-29.696-23.552-54.272-52.224-54.272h-241.152z">
                                    </path>
                                </svg>
                            </div>
                            <div>
                                <div class="font-medium text-base-content">{{ $tt('格式转换') }}</div>
                                <div class="text-sm text-base-content/70">{{ $tt('转换音频格式和比特率') }}</div>
                            </div>
                        </div>
                        <div class="flex-shrink-0">
                            <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                            <svg v-else class="w-5 h-5 fill-current text-base-content/50" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 分割音轨按钮卡片 -->
            <div
                class="card bg-base-100 border border-base-200 hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
                <div class="card-body p-4">
                    <div @click="splitCueCheckBox = true" class="flex items-center justify-between cursor-pointer">
                        <div class="flex items-center space-x-3">
                            <div class="p-2 bg-warning/10 rounded-lg">
                                <svg viewBox="0 0 16 14" class="w-6 h-6 fill-warning"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M6.00001 0.750244C6.00001 0.33603 5.66422 0.000244141 5.25001 0.000244141C4.83579 0.000244141 4.50001 0.336031 4.50001 0.750244L4.50001 1.10975C4.50001 1.72344 4.75068 2.31051 5.19395 2.73492L7.26701 4.71982L4.82988 7.09988C4.42039 7.49039 4.31633 8.10894 4.59285 8.61168L4.60292 8.63001L6.88601 12.2829C6.96051 12.4021 7.00001 12.5399 7.00001 12.6804V13.2502C7.00001 13.6645 7.33579 14.0002 7.75001 14.0002C8.16422 14.0002 8.50001 13.6645 8.50001 13.2502L8.50001 12.6804C8.50001 12.2587 8.3815 11.8455 8.158 11.4879L6.00724 8.04672L8.47876 5.63307C8.8733 5.28191 8.97223 4.73973 8.81074 4.29147C8.7162 4.02904 8.53253 3.85435 8.46556 3.79066L8.45717 3.78266L6.23132 1.65147C6.08357 1.51 6.00001 1.31431 6.00001 1.10975L6.00001 0.750244Z" />
                                </svg>
                            </div>
                            <div>
                                <div class="font-medium text-base-content">{{ $tt('分割音轨') }}</div>
                                <div class="text-sm text-base-content/70">{{ $tt('使用CUE文件分割音轨') }}</div>
                            </div>
                        </div>
                        <div class="flex-shrink-0">
                            <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                            <svg v-else class="w-5 h-5 fill-current text-base-content/50" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 导入收藏按钮 -->
            <div
                class="card bg-base-100 border border-base-200 hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
                <div class="card-body p-4">
                    <div @click="importMusicCheckBox = true" class="flex items-center justify-between cursor-pointer">
                        <div class="flex items-center space-x-3">
                            <div class="p-2 bg-warning/10 rounded-lg">
                                <svg-icon name="import-music" class="w-5 h-5 fill-warning" />
                            </div>
                            <div>
                                <div class="font-medium text-base-content">{{ $tt('导入收藏') }}</div>
                                <div class="text-sm text-base-content/70">{{ $tt('将本地音乐导入到音乐收藏库中') }}</div>
                            </div>
                        </div>
                        <div class="flex-shrink-0">
                            <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                            <svg v-else class="w-5 h-5 fill-current text-base-content/50" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 重复文件检查按钮 -->
            <div
                class="card bg-base-100 border border-base-200 hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
                <div class="card-body p-4">
                    <div @click="duplicateCheckBox = true" class="flex items-center justify-between cursor-pointer">
                        <div class="flex items-center space-x-3">
                            <div class="p-2 bg-error/10 rounded-lg">
                                <svg-icon name="import-music" class="w-5 h-5 fill-error" />
                            </div>
                            <div>
                                <div class="font-medium text-base-content">{{ $tt('重复文件检查') }}</div>
                                <div class="text-sm text-base-content/70">{{ $tt('快速检查出重复文件进行删除') }}</div>
                            </div>
                        </div>
                        <div class="flex-shrink-0">
                            <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                            <svg v-else class="w-5 h-5 fill-current text-base-content/50" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 回放增益按钮 -->
            <div
                class="card bg-base-100 border border-base-200 hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
                <div class="card-body p-4">
                    <div for="change-format" class="flex items-center justify-between cursor-pointer" @click="gainCheckBox = true">
                        <div class="flex items-center space-x-3">
                            <div class="p-2 bg-accent/10 rounded-lg">
                                <svg t="1704704621435" class="w-6 h-6 fill-accent" viewBox="0 0 1024 1024" version="1.1"
                                    xmlns="http://www.w3.org/2000/svg" p-id="3438">
                                    <path
                                        d="M136.192 986.112C66.56 986.112 10.24 927.744 10.24 856.576v-141.312c0-71.68 56.32-130.048 125.952-130.048h241.664c69.632 0 125.952 58.368 125.952 130.048v141.312c0 71.68-56.32 130.048-125.952 130.048H136.192z m0-325.12c-28.672 0-52.224 24.064-52.224 54.272v141.312c0 29.696 23.552 54.272 52.224 54.272h241.152c28.672 0 52.224-24.064 52.224-54.272v-141.312c0-29.696-23.552-54.272-52.224-54.272H136.192z m485.888 308.736c-19.968 0-31.232-15.872-31.744-31.232-0.512-14.848 8.192-32.768 35.84-35.328 26.112-4.608 46.08-8.704 70.144-16.896l1.024-0.512h1.024c9.216 0 40.448-22.528 66.56-53.76l0.512-1.024 1.536-1.024h0.512c14.336-7.168 38.912-48.64 51.712-96.256 0.512-3.072 1.024-5.632 1.536-8.192l0.512-2.56c3.072-16.896 6.144-31.744 6.144-49.152 0-2.048 0-5.12-0.512-10.24-0.512-3.072-0.512-5.632-0.512-8.704l-37.376 45.568c-9.728 10.752-18.944 12.8-25.088 12.8-4.096 0-8.704-1.024-12.8-3.072-9.728-5.12-15.36-11.776-17.408-20.48-2.56-11.264 3.584-21.504 6.144-25.088l0.512-0.512 84.992-105.472c3.072-3.072 20.48-19.456 38.912-19.456 26.112 0 40.448 23.04 44.032 29.184l76.288 110.08s12.288 17.408-9.216 39.936c-7.168 7.168-15.36 11.264-23.04 11.264-9.728 0-15.872-5.632-16.896-6.656l-42.496-56.832v16.896c0 60.928-20.48 119.808-60.928 175.104-40.448 50.688-86.528 83.456-140.8 101.376-2.048 1.024-5.12 2.048-13.312 4.096l-4.096 1.024c-12.288 3.072-23.552 5.12-33.28 6.656h-18.432z m-456.704-451.584c-28.672 0-43.008-26.624-44.544-30.208l-71.68-113.152s-12.288-17.408 9.216-39.424c7.68-7.168 15.36-11.264 23.04-11.264 9.728 0 15.872 5.632 16.896 6.656l42.496 56.32v-1.536-6.144c0.512-25.6 3.584-51.2 8.704-75.776 11.776-48.64 38.912-94.208 82.432-139.776 41.984-38.912 90.624-64 139.776-72.192 17.408-4.608 34.816-4.608 52.224-4.608 9.728 0 15.36 13.312 15.872 26.112 1.024 17.92-7.68 37.888-35.84 40.96l-2.048 0.512c-19.968 4.096-40.448 8.192-59.904 16.384-38.4 15.872-67.584 39.936-94.72 76.8l-4.608 6.656-2.048-1.536c-6.144 8.704-20.992 35.84-28.672 71.168l-0.512 3.072-0.512 1.536v0.512c-0.512 2.048-5.12 25.088-5.12 51.2v4.096c0 3.072 0.512 6.656 0.512 9.728 0 1.536 0 2.56 0.512 4.096l33.792-40.96c9.728-10.752 18.944-12.8 25.088-12.8 4.608 0 8.704 1.024 12.8 3.072 9.728 5.12 15.36 11.776 17.408 19.968 1.536 7.68-0.512 16.896-6.144 25.088v0.512L204.8 498.176c-3.584 3.584-20.992 19.968-39.424 19.968z m471.04-42.496c-69.632 0-125.952-58.368-125.952-130.048V204.8c0-71.68 56.32-130.048 125.952-130.048h241.152C947.2 74.752 1003.52 133.12 1003.52 204.8v141.312c0 71.68-56.32 130.048-125.952 130.048h-241.152z m0-325.12c-28.672 0-52.224 24.064-52.224 54.272v141.312c0 29.696 23.552 54.272 52.224 54.272h241.152c28.672 0 52.224-24.064 52.224-54.272V204.8c0-29.696-23.552-54.272-52.224-54.272h-241.152z">
                                    </path>
                                </svg>
                            </div>
                            <div>
                                <div class="font-medium text-base-content">{{ $tt('回放增益') }}</div>
                                <div class="text-sm text-base-content/70">{{ $tt('预先计算的增益值自动调整音量') }}</div>
                            </div>
                        </div>
                        <div class="flex-shrink-0">
                            <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                            <svg v-else class="w-5 h-5 fill-current text-base-content/50" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 生成strm文件按钮 -->
            <div
                class="card bg-base-100 border border-base-200 hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
                <div class="card-body p-4">
                    <div for="change-format" class="flex items-center justify-between cursor-pointer" @click="generateStrmCheckBox = true">
                        <div class="flex items-center space-x-3">
                            <div class="p-2 bg-primary/10 rounded-lg">
                                <svg t="1704704621435" class="w-6 h-6 fill-primary" viewBox="0 0 1024 1024" version="1.1"
                                    xmlns="http://www.w3.org/2000/svg" p-id="3438">
                                    <path
                                        d="M136.192 986.112C66.56 986.112 10.24 927.744 10.24 856.576v-141.312c0-71.68 56.32-130.048 125.952-130.048h241.664c69.632 0 125.952 58.368 125.952 130.048v141.312c0 71.68-56.32 130.048-125.952 130.048H136.192z m0-325.12c-28.672 0-52.224 24.064-52.224 54.272v141.312c0 29.696 23.552 54.272 52.224 54.272h241.152c28.672 0 52.224-24.064 52.224-54.272v-141.312c0-29.696-23.552-54.272-52.224-54.272H136.192z m485.888 308.736c-19.968 0-31.232-15.872-31.744-31.232-0.512-14.848 8.192-32.768 35.84-35.328 26.112-4.608 46.08-8.704 70.144-16.896l1.024-0.512h1.024c9.216 0 40.448-22.528 66.56-53.76l0.512-1.024 1.536-1.024h0.512c14.336-7.168 38.912-48.64 51.712-96.256 0.512-3.072 1.024-5.632 1.536-8.192l0.512-2.56c3.072-16.896 6.144-31.744 6.144-49.152 0-2.048 0-5.12-0.512-10.24-0.512-3.072-0.512-5.632-0.512-8.704l-37.376 45.568c-9.728 10.752-18.944 12.8-25.088 12.8-4.096 0-8.704-1.024-12.8-3.072-9.728-5.12-15.36-11.776-17.408-20.48-2.56-11.264 3.584-21.504 6.144-25.088l0.512-0.512 84.992-105.472c3.072-3.072 20.48-19.456 38.912-19.456 26.112 0 40.448 23.04 44.032 29.184l76.288 110.08s12.288 17.408-9.216 39.936c-7.168 7.168-15.36 11.264-23.04 11.264-9.728 0-15.872-5.632-16.896-6.656l-42.496-56.832v16.896c0 60.928-20.48 119.808-60.928 175.104-40.448 50.688-86.528 83.456-140.8 101.376-2.048 1.024-5.12 2.048-13.312 4.096l-4.096 1.024c-12.288 3.072-23.552 5.12-33.28 6.656h-18.432z m-456.704-451.584c-28.672 0-43.008-26.624-44.544-30.208l-71.68-113.152s-12.288-17.408 9.216-39.424c7.68-7.168 15.36-11.264 23.04-11.264 9.728 0 15.872 5.632 16.896 6.656l42.496 56.32v-1.536-6.144c0.512-25.6 3.584-51.2 8.704-75.776 11.776-48.64 38.912-94.208 82.432-139.776 41.984-38.912 90.624-64 139.776-72.192 17.408-4.608 34.816-4.608 52.224-4.608 9.728 0 15.36 13.312 15.872 26.112 1.024 17.92-7.68 37.888-35.84 40.96l-2.048 0.512c-19.968 4.096-40.448 8.192-59.904 16.384-38.4 15.872-67.584 39.936-94.72 76.8l-4.608 6.656-2.048-1.536c-6.144 8.704-20.992 35.84-28.672 71.168l-0.512 3.072-0.512 1.536v0.512c-0.512 2.048-5.12 25.088-5.12 51.2v4.096c0 3.072 0.512 6.656 0.512 9.728 0 1.536 0 2.56 0.512 4.096l33.792-40.96c9.728-10.752 18.944-12.8 25.088-12.8 4.608 0 8.704 1.024 12.8 3.072 9.728 5.12 15.36 11.776 17.408 19.968 1.536 7.68-0.512 16.896-6.144 25.088v0.512L204.8 498.176c-3.584 3.584-20.992 19.968-39.424 19.968z m471.04-42.496c-69.632 0-125.952-58.368-125.952-130.048V204.8c0-71.68 56.32-130.048 125.952-130.048h241.152C947.2 74.752 1003.52 133.12 1003.52 204.8v141.312c0 71.68-56.32 130.048-125.952 130.048h-241.152z m0-325.12c-28.672 0-52.224 24.064-52.224 54.272v141.312c0 29.696 23.552 54.272 52.224 54.272h241.152c28.672 0 52.224-24.064 52.224-54.272V204.8c0-29.696-23.552-54.272-52.224-54.272h-241.152z">
                                    </path>
                                </svg>
                            </div>
                            <div>
                                <div class="font-medium text-base-content">{{ $tt('生成strm文件') }}</div>
                                <div class="text-sm text-base-content/70">{{ $tt('生成音乐流文件') }}</div>
                            </div>
                        </div>
                        <div class="flex-shrink-0">
                            <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                            <svg v-else class="w-5 h-5 fill-current text-base-content/50" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clip-rule="evenodd" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 桌面端原有模式 -->
        <div v-else>
            <!-- 格式转换按钮 -->
            <div class="mt-2">
                <div for="change-format"
                    :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                    :data-tip="$tt('格式转换')" :disabled="isLoading" @click="formatMusicCheckBox = true">
                    <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                    <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                        <svg t="1704704621435" class="icon fill-current w-16 h-6" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="3438" width="200" height="200">
                            <path
                                d="M136.192 986.112C66.56 986.112 10.24 927.744 10.24 856.576v-141.312c0-71.68 56.32-130.048 125.952-130.048h241.664c69.632 0 125.952 58.368 125.952 130.048v141.312c0 71.68-56.32 130.048-125.952 130.048H136.192z m0-325.12c-28.672 0-52.224 24.064-52.224 54.272v141.312c0 29.696 23.552 54.272 52.224 54.272h241.152c28.672 0 52.224-24.064 52.224-54.272v-141.312c0-29.696-23.552-54.272-52.224-54.272H136.192z m485.888 308.736c-19.968 0-31.232-15.872-31.744-31.232-0.512-14.848 8.192-32.768 35.84-35.328 26.112-4.608 46.08-8.704 70.144-16.896l1.024-0.512h1.024c9.216 0 40.448-22.528 66.56-53.76l0.512-1.024 1.536-1.024h0.512c14.336-7.168 38.912-48.64 51.712-96.256 0.512-3.072 1.024-5.632 1.536-8.192l0.512-2.56c3.072-16.896 6.144-31.744 6.144-49.152 0-2.048 0-5.12-0.512-10.24-0.512-3.072-0.512-5.632-0.512-8.704l-37.376 45.568c-9.728 10.752-18.944 12.8-25.088 12.8-4.096 0-8.704-1.024-12.8-3.072-9.728-5.12-15.36-11.776-17.408-20.48-2.56-11.264 3.584-21.504 6.144-25.088l0.512-0.512 84.992-105.472c3.072-3.072 20.48-19.456 38.912-19.456 26.112 0 40.448 23.04 44.032 29.184l76.288 110.08s12.288 17.408-9.216 39.936c-7.168 7.168-15.36 11.264-23.04 11.264-9.728 0-15.872-5.632-16.896-6.656l-42.496-56.832v16.896c0 60.928-20.48 119.808-60.928 175.104-40.448 50.688-86.528 83.456-140.8 101.376-2.048 1.024-5.12 2.048-13.312 4.096l-4.096 1.024c-12.288 3.072-23.552 5.12-33.28 6.656h-18.432z m-456.704-451.584c-28.672 0-43.008-26.624-44.544-30.208l-71.68-113.152s-12.288-17.408 9.216-39.424c7.68-7.168 15.36-11.264 23.04-11.264 9.728 0 15.872 5.632 16.896 6.656l42.496 56.32v-1.536-6.144c0.512-25.6 3.584-51.2 8.704-75.776 11.776-48.64 38.912-94.208 82.432-139.776 41.984-38.912 90.624-64 139.776-72.192 17.408-4.608 34.816-4.608 52.224-4.608 9.728 0 15.36 13.312 15.872 26.112 1.024 17.92-7.68 37.888-35.84 40.96l-2.048 0.512c-19.968 4.096-40.448 8.192-59.904 16.384-38.4 15.872-67.584 39.936-94.72 76.8l-4.608 6.656-2.048-1.536c-6.144 8.704-20.992 35.84-28.672 71.168l-0.512 3.072-0.512 1.536v0.512c-0.512 2.048-5.12 25.088-5.12 51.2v4.096c0 3.072 0.512 6.656 0.512 9.728 0 1.536 0 2.56 0.512 4.096l33.792-40.96c9.728-10.752 18.944-12.8 25.088-12.8 4.608 0 8.704 1.024 12.8 3.072 9.728 5.12 15.36 11.776 17.408 19.968 1.536 7.68-0.512 16.896-6.144 25.088v0.512L204.8 498.176c-3.584 3.584-20.992 19.968-39.424 19.968z m471.04-42.496c-69.632 0-125.952-58.368-125.952-130.048V204.8c0-71.68 56.32-130.048 125.952-130.048h241.152C947.2 74.752 1003.52 133.12 1003.52 204.8v141.312c0 71.68-56.32 130.048-125.952 130.048h-241.152z m0-325.12c-28.672 0-52.224 24.064-52.224 54.272v141.312c0 29.696 23.552 54.272 52.224 54.272h241.152c28.672 0 52.224-24.064 52.224-54.272V204.8c0-29.696-23.552-54.272-52.224-54.272h-241.152z">
                            </path>
                        </svg>
                        <div v-if="detail" class="mr-auto">{{ $tt('格式转换') }}</div>
                    </span>
                </div>
            </div>

            <!-- 分割音轨按钮 -->
            <div class="mt-2">
                <div for="split_cue"
                    :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                    :data-tip="$tt('分割音轨')" :disabled="isLoading" @click="splitCueCheckBox = true">
                    <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                    <span v-else :class="['flex mt-1', 'items-center', detail ? 'w-40' : '']">
                        <svg viewBox="0 0 16 14" class="icon fill-current w-16 h-5" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M6.00001 0.750244C6.00001 0.33603 5.66422 0.000244141 5.25001 0.000244141C4.83579 0.000244141 4.50001 0.336031 4.50001 0.750244L4.50001 1.10975C4.50001 1.72344 4.75068 2.31051 5.19395 2.73492L7.26701 4.71982L4.82988 7.09988C4.42039 7.49039 4.31633 8.10894 4.59285 8.61168L4.60292 8.63001L6.88601 12.2829C6.96051 12.4021 7.00001 12.5399 7.00001 12.6804V13.2502C7.00001 13.6645 7.33579 14.0002 7.75001 14.0002C8.16422 14.0002 8.50001 13.6645 8.50001 13.2502L8.50001 12.6804C8.50001 12.2587 8.3815 11.8455 8.158 11.4879L6.00724 8.04672L8.47876 5.63307C8.8733 5.28191 8.97223 4.73973 8.81074 4.29147C8.7162 4.02904 8.53253 3.85435 8.46556 3.79066L8.45717 3.78266L6.23132 1.65147C6.08357 1.51 6.00001 1.31431 6.00001 1.10975L6.00001 0.750244Z" />
                            <path
                                d="M2.5 1.75024C2.08421 1.75024 1.75 2.08446 1.75 2.50024V11.5002C1.75 11.916 2.08421 12.2502 2.5 12.2502H5.25C5.66421 12.2502 6 12.586 6 13.0002C6 13.4145 5.66421 13.7502 5.25 13.7502H2.5C1.25579 13.7502 0.25 12.7445 0.25 11.5002V2.50024C0.25 1.25603 1.25579 0.250244 2.5 0.250244H3.11C3.52421 0.250244 3.86 0.586031 3.86 1.00024C3.86 1.41446 3.52421 1.75024 3.11 1.75024H2.5Z" />
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M8.47296 2.23137C7.87783 1.41306 8.4474 0.250244 9.47952 0.250244H13.4995C14.7437 0.250244 15.7495 1.25603 15.7495 2.50024V11.5002C15.7495 12.7445 14.7437 13.7502 13.4995 13.7502H11.1795C10.7359 13.7502 10.302 13.5087 10.0856 13.0893L7.90236 9.06168L7.90098 9.05917C7.63468 8.57234 7.71835 7.95284 8.13705 7.5617L10.6534 4.96992L8.48264 2.24467L8.47296 2.23137ZM10.0065 1.75024L11.9884 4.23833L11.9998 4.25432C12.3627 4.7623 12.2997 5.45211 11.8588 5.88178L9.30861 8.50837L11.337 12.2502H13.4995C13.9153 12.2502 14.2495 11.916 14.2495 11.5002V2.50024C14.2495 2.08446 13.9153 1.75024 13.4995 1.75024H10.0065Z" />
                        </svg>
                        <div v-if="detail" class="mr-auto">{{ $tt('分割音轨') }}</div>
                    </span>
                </div>
            </div>

            <!-- 导入收藏按钮 -->
            <div class="mt-2">
                <button :theme="'success'" @click="importMusicCheckBox = true"
                    :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                    :data-tip="$tt('导入收藏')">
                    <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                    <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                        <svg-icon name="import-music" class="w-16 h-6 fill-current" />
                        <div v-if="detail" class="mr-auto">{{ $tt('导入收藏') }}</div>
                    </span>
                </button>
            </div>

            <!-- 重复文件检查按钮 -->
            <div class="mt-2">
                <button :theme="'success'" @click="duplicateCheckBox = true"
                    :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                    :data-tip="$tt('重复文件检查')" :disabled="isLoading">
                    <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                    <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                        <svg-icon name="duplicate-file" class="w-16 h-6 fill-current" />
                        <div v-if="detail" class="mr-auto">{{ $tt('重复文件检查') }}</div>
                    </span>
                </button>
            </div>

            <!-- 回放增益按钮 -->
            <div class="mt-2">
                <button :theme="'success'" @click="gainCheckBox = true"
                    :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                    :data-tip="$tt('回放增益')" :disabled="isLoading">
                    <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                    <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                        <svg-icon name="gain" class="w-16 h-6 fill-current" />
                        <div v-if="detail" class="mr-auto">{{ $tt('回放增益') }}</div>
                    </span>
                </button>
            </div>

            <!-- 生成strm文件按钮 -->
            <div class="mt-2">
                <button :theme="'success'" @click="generateStrmCheckBox = true"
                    :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                    :data-tip="$tt('生成 strm 文件')" :disabled="isLoading">
                    <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                    <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                        <svg-icon name="cloud-down" class="w-16 h-8 fill-current" />
                        <div v-if="detail" class="mr-auto">{{ $tt('生成strm文件') }}</div>
                    </span>
                </button>
            </div>

        </div>
        <!-- 生成strm文件 Modal -->
        <div class="drawer">
            <input id="generate_strm" type="checkbox" class="drawer-toggle" v-model="generateStrmCheckBox" />
            <div class="drawer-side z-50">
                <div @click="generateStrmCheckBox = false" aria-label="close sidebar" class="drawer-overlay"></div>
                <div class="min-h-full bg-base-100 text-base-content w-full md:w-96 pb-20 md:pb-4 flex flex-col">
                    <!-- 标准头部 -->
                    <div class="flex items-center justify-between p-4 border-b border-base-200">
                        <div class="text-xl font-medium">{{ $tt('生成strm文件') }}</div>
                        <div>
                            <button class="btn btn-sm btn-neutral" @click="generateStrm" v-if="userRole === 'V2'">{{ $tt('确认') }}</button>
                            <button class="btn btn-sm btn-neutral opacity-50 cursor-not-allowed" v-else>{{ $tt('确认(V2功能)') }}</button>
                            <button class="btn btn-sm ml-1" @click="generateStrmCheckBox = false">{{ $tt('取消') }}</button>
                        </div>
                    </div>
                    
                    <!-- 内容区域 -->
                    <div class="flex-1 p-4 space-y-6 overflow-y-auto">
                        <!-- 功能说明分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-primary/40 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('功能说明') }}</h3>
                                <div class="badge badge-primary badge-outline badge-sm">{{ $tt('流媒体') }}</div>
                            </div>
                            <div class="ml-4 pl-3 border-l border-base-200">
                                <div class="space-y-2 text-sm text-base-content/60">
                                    <p>{{ $tt('• 将音乐文件转换为 STRM 流媒体文件') }}</p>
                                    <p>{{ $tt('• 适用于媒体服务器和播放器集成') }}</p>
                                    <p>{{ $tt('• 支持签名验证，提高安全性') }}</p>
                                    <p>{{ $tt('• 可自定义保存位置') }}</p>
                                </div>
                            </div>
                        </div>

                        <!-- 输出设置分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-base-content/20 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('输出设置') }}</h3>
                                <div class="badge badge-ghost badge-sm">{{ $tt('文件配置') }}</div>
                            </div>
                            <div class="ml-4 pl-3 border-l border-base-200 space-y-3">
                                <!-- 保存目录 -->
                                <div class="form-control">
                                    <label class="label cursor-pointer justify-start space-x-3 py-2">
                                        <div class="flex-1">
                                            <span class="label-text font-medium">{{ $tt('保存目录') }}</span>
                                            <div class="text-xs text-base-content/60 mt-1">{{ $tt('指定STRM文件的保存位置') }}</div>
                                        </div>
                                    </label>
                                    <input type="text" :placeholder="$tt('默认保存到当前目录')" 
                                        class="input input-bordered input-sm w-full" v-model="saveDir" />
                                    <div class="text-xs text-base-content/50 mt-2">{{ $tt('留空则保存到当前目录') }}</div>
                                </div>

                                <!-- 签名选项 -->
                                <div class="form-control">
                                    <label class="label cursor-pointer justify-start space-x-3 py-2">
                                        <input type="checkbox" class="toggle toggle-primary" v-model="isSign" />
                                        <div class="flex-1">
                                            <span class="label-text font-medium">{{ $tt('启用签名验证') }}</span>
                                            <div class="text-xs text-base-content/60 mt-1">{{ $tt('为OpenList提供签名验证支持') }}</div>
                                        </div>
                                    </label>
                                    <div v-if="isSign" class="bg-warning/10 rounded-lg p-3 mt-2">
                                        <div class="flex items-start space-x-2">
                                            <div class="w-4 h-4 bg-warning/20 rounded-full flex items-center justify-center mt-0.5">
                                                <svg class="w-2.5 h-2.5 text-warning" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                                                </svg>
                                            </div>
                                            <div class="flex-1">
                                                <p class="text-xs text-base-content/70">{{ $tt('开启签名后扫描速度会有所降低') }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 回放增益 Drawer -->
        <div class="drawer">
            <input id="gain" type="checkbox" class="drawer-toggle" v-model="gainCheckBox" />
            <div class="drawer-side z-50">
                <div @click="gainCheckBox = false" aria-label="close sidebar" class="drawer-overlay"></div>
                <div class="min-h-full bg-base-100 text-base-content w-full md:w-96 pb-20 md:pb-4 flex flex-col">
                    <!-- 标准头部 -->
                    <div class="flex items-center justify-between p-4 border-b border-base-200">
                        <div class="text-xl font-medium">{{ $tt('回放增益') }}</div>
                        <div>
                            <button class="btn btn-sm btn-neutral" @click="handleReplayGain" v-if="userRole === 'V2'">{{ $tt('确认') }}</button>
                            <button class="btn btn-sm btn-neutral opacity-50 cursor-not-allowed" v-else>{{ $tt('确认(V2功能)') }}</button>
                            <button class="btn btn-sm ml-1" @click="gainCheckBox = false">{{ $tt('取消') }}</button>
                        </div>
                    </div>
                    
                    <!-- 内容区域 -->
                    <div class="flex-1 p-4 space-y-6 overflow-y-auto">
                        <!-- 功能说明分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-primary/40 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('功能说明') }}</h3>
                                <div class="badge badge-primary badge-outline badge-sm">{{ $tt('音量平衡') }}</div>
                            </div>
                            <div class="ml-4 pl-3 border-l border-base-200">
                                <div class="space-y-2 text-sm text-base-content/60">
                                    <p>{{ $tt('• 通过扫描各个文件的音量大小，计算回放增益值') }}</p>
                                    <p>{{ $tt('• 将回放增益信息写入文件的属性标签中') }}</p>
                                    <p>{{ $tt('• 播放时通过回放增益统一音量大小') }}</p>
                                    <p>{{ $tt('• 提供更一致的听音体验') }}</p>
                                </div>
                            </div>
                        </div>

                        <!-- 环境要求分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-warning/40 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('环境要求') }}</h3>
                                <div class="badge badge-warning badge-outline badge-sm">{{ $tt('依赖组件') }}</div>
                            </div>
                            <div class="ml-4 pl-3 border-l border-base-200">
                                <div class="bg-warning/10 rounded-lg p-4">
                                    <div class="flex items-start space-x-3">
                                        <div class="w-5 h-5 bg-warning/20 rounded-full flex items-center justify-center mt-0.5">
                                            <svg class="w-3 h-3 text-warning" fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                                            </svg>
                                        </div>
                                        <div class="flex-1">
                                            <h4 class="font-medium text-base-content mb-2">{{ $tt('需要 FFmpeg 支持') }}</h4>
                                            <div class="space-y-2 text-sm text-base-content/70">
                                                <p>{{ $tt('• 下载') }} <a href="https://johnvansickle.com/ffmpeg/" target="_blank" class="text-primary hover:underline font-medium">{{ $tt('FFmpeg 可执行文件') }}</a></p>
                                                <p>{{ $tt('• 放置在挂载的') }} <code class="bg-base-200 px-2 py-1 rounded text-xs">/app/data/bin/</code> {{ $tt('目录下') }}</p>
                                                <p>{{ $tt('• 确保文件具有执行权限') }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 注意事项分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-base-content/20 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('注意事项') }}</h3>
                                <div class="badge badge-ghost badge-sm">{{ $tt('重要提示') }}</div>
                            </div>
                            <div class="ml-4 pl-3 border-l border-base-200">
                                <div class="space-y-3">
                                    <div class="flex items-start space-x-3 p-3 bg-base-200/30 rounded-lg">
                                        <div class="w-5 h-5 bg-info/20 rounded-full flex items-center justify-center mt-0.5">
                                            <svg class="w-3 h-3 text-info" fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
                                            </svg>
                                        </div>
                                        <div class="flex-1">
                                            <p class="text-sm text-base-content/70">{{ $tt('处理过程可能需要较长时间，请耐心等待') }}</p>
                                        </div>
                                    </div>
                                    <div class="flex items-start space-x-3 p-3 bg-base-200/30 rounded-lg">
                                        <div class="w-5 h-5 bg-success/20 rounded-full flex items-center justify-center mt-0.5">
                                            <svg class="w-3 h-3 text-success" fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                                            </svg>
                                        </div>
                                        <div class="flex-1">
                                            <p class="text-sm text-base-content/70">{{ $tt('可在操作记录中查看处理进度和结果') }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 重复文件检查 Drawer -->
        <div class="drawer">
            <input id="duplicate_check" type="checkbox" class="drawer-toggle" v-model="duplicateCheckBox" />
            <div class="drawer-side z-50">
                <div @click="duplicateCheckBox = false" aria-label="close sidebar" class="drawer-overlay"></div>
                <div class="min-h-full bg-base-100 text-base-content w-full md:w-96 pb-20 md:pb-4 flex flex-col">
                    <!-- 标准头部 -->
                    <div class="flex items-center justify-between p-4 border-b border-base-200">
                        <div class="text-xl font-medium">{{ $tt('重复文件检查') }}</div>
                        <div>
                            <button class="btn btn-sm btn-neutral" @click="checkForDuplicates" v-if="userRole === 'V2'">{{ $tt('确认') }}</button>
                            <button class="btn btn-sm btn-neutral opacity-50 cursor-not-allowed" v-else>{{ $tt('确认(V2功能)') }}</button>
                            <button class="btn btn-sm ml-1" @click="duplicateCheckBox = false">{{ $tt('取消') }}</button>
                        </div>
                    </div>
                    
                    <!-- 内容区域 -->
                    <div class="flex-1 p-4 space-y-6 overflow-y-auto">
                        <!-- 功能说明分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-warning/40 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('功能说明') }}</h3>
                                <div class="badge badge-warning badge-outline badge-sm">{{ $tt('重复检测') }}</div>
                            </div>
                            <div class="ml-4 pl-3 border-l border-base-200">
                                <div class="space-y-2 text-sm text-base-content/60">
                                    <p>{{ $tt('• 智能查找重复的音乐文件，支持多种检测方式') }}</p>
                                    <p>{{ $tt('• 不会自动删除文件，安全可靠') }}</p>
                                    <p>{{ $tt('• 可在操作记录中查看详细结果并进行后续处理') }}</p>
                                    <p>{{ $tt('• 支持 Hash 校验和文件名相似度检测') }}</p>
                                </div>
                            </div>
                        </div>

                        <!-- 检测方式分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-primary/40 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('检测方式') }}</h3>
                                <div class="badge badge-primary badge-outline badge-sm">{{ $tt('多重校验') }}</div>
                            </div>
                            <div class="ml-4 pl-3 border-l border-base-200 space-y-3">
                                <div class="grid grid-cols-1 gap-3">
                                    <div class="flex items-center space-x-3 p-3 bg-base-200/30 rounded-lg">
                                        <div class="w-8 h-8 bg-success/10 rounded-lg flex items-center justify-center">
                                            <svg class="w-4 h-4 text-success" fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd"
                                                    d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                                                    clip-rule="evenodd"></path>
                                            </svg>
                                        </div>
                                        <div class="flex-1">
                                            <p class="font-medium text-sm">{{ $tt('Hash 校验') }}</p>
                                            <p class="text-xs text-base-content/60">{{ $tt('基于文件内容哈希值检测完全相同的文件') }}</p>
                                        </div>
                                    </div>
                                    <div class="flex items-center space-x-3 p-3 bg-base-200/30 rounded-lg">
                                        <div class="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
                                            <svg class="w-4 h-4 text-primary" fill="currentColor" viewBox="0 0 20 20">
                                                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                            </svg>
                                        </div>
                                        <div class="flex-1">
                                            <p class="font-medium text-sm">{{ $tt('文件名校验') }}</p>
                                            <p class="text-xs text-base-content/60">{{ $tt('基于文件名相似度检测可能重复的文件') }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 高级选项分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-base-content/20 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('高级选项') }}</h3>
                                <div class="badge badge-ghost badge-sm">{{ $tt('精准识别') }}</div>
                            </div>
                            <div class="ml-4 pl-3 border-l border-base-200 space-y-3">
                                <div class="form-control">
                                    <label class="label cursor-pointer justify-start space-x-3 py-2">
                                        <input type="checkbox" class="toggle toggle-warning" v-model="isAcoustid" />
                                        <div class="flex-1">
                                            <span class="label-text font-medium">{{ $tt('启用声纹重复校验') }}</span>
                                            <div class="text-xs text-base-content/60 mt-1">{{ $tt('通过音频特征识别重复文件，精度更高但速度相对较慢') }}</div>
                                        </div>
                                    </label>
                                    <div v-if="isAcoustid" class="bg-warning/10 rounded-lg p-3 mt-2">
                                        <div class="flex items-start space-x-2">
                                            <div class="w-4 h-4 bg-warning/20 rounded-full flex items-center justify-center mt-0.5">
                                                <svg class="w-2.5 h-2.5 text-warning" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                                                </svg>
                                            </div>
                                            <div class="flex-1">
                                                <p class="text-xs text-base-content/70">{{ $tt('启用声纹识别后检测速度会显著降低，请耐心等待') }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- 音乐元数据对比选项 -->
                                <div class="form-control">
                                    <label class="label cursor-pointer justify-start space-x-3 py-2">
                                        <input type="checkbox" class="toggle toggle-info" v-model="isMetadataCompare" />
                                        <div class="flex-1">
                                            <span class="label-text font-medium">{{ $tt('启用音乐元数据对比') }}</span>
                                            <div class="text-xs text-base-content/60 mt-1">{{ $tt('基于音乐收藏中标题、艺术家、专辑等元数据识别重复文件') }}</div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>

                        <!-- 注意事项分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-info/40 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('注意事项') }}</h3>
                                <div class="badge badge-info badge-outline badge-sm">{{ $tt('重要提示') }}</div>
                            </div>
                            <div class="ml-4 pl-3 border-l border-base-200">
                                <div class="space-y-3">
                                    <div class="flex items-start space-x-3 p-3 bg-base-200/30 rounded-lg">
                                        <div class="w-5 h-5 bg-success/20 rounded-full flex items-center justify-center mt-0.5">
                                            <svg class="w-3 h-3 text-success" fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                                            </svg>
                                        </div>
                                        <div class="flex-1">
                                            <p class="text-sm text-base-content/70">{{ $tt('系统只会检测重复文件，不会自动删除任何内容') }}</p>
                                        </div>
                                    </div>
                                    <div class="flex items-start space-x-3 p-3 bg-base-200/30 rounded-lg">
                                        <div class="w-5 h-5 bg-info/20 rounded-full flex items-center justify-center mt-0.5">
                                            <svg class="w-3 h-3 text-info" fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
                                            </svg>
                                        </div>
                                        <div class="flex-1">
                                            <p class="text-sm text-base-content/70">{{ $tt('检测结果将显示在操作记录中，可根据需要手动处理') }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 导入收藏 Drawer -->
        <div class="drawer">
            <input id="import_music" type="checkbox" class="drawer-toggle" v-model="importMusicCheckBox" />
            <div class="drawer-side z-50">
                <div @click="importMusicCheckBox = false" aria-label="close sidebar" class="drawer-overlay"></div>
                <div class="min-h-full bg-base-100 text-base-content w-full md:w-96 pb-20 md:pb-4 flex flex-col">
                    <!-- 标准头部 -->
                    <div class="flex items-center justify-between p-4 border-b border-base-200">
                        <div class="text-xl font-medium">{{ $tt('导入收藏') }}</div>
                        <div>
                            <button class="btn btn-sm btn-neutral" @click="importMusic" v-if="userRole === 'V2'">{{ $tt('确认') }}</button>
                            <button class="btn btn-sm btn-neutral opacity-50 cursor-not-allowed" v-else>{{ $tt('确认(V2功能)') }}</button>
                            <button class="btn btn-sm ml-1" @click="importMusicCheckBox = false">{{ $tt('取消') }}</button>
                        </div>
                    </div>
                    
                    <!-- 内容区域 -->
                    <div class="flex-1 p-4 space-y-6 overflow-y-auto">
                        <!-- 功能说明分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-warning/40 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('功能说明') }}</h3>
                                <div class="badge badge-warning badge-outline badge-sm">{{ $tt('音乐导入') }}</div>
                            </div>
                            <div class="ml-4 pl-3 border-l border-base-200">
                                <div class="space-y-2 text-sm text-base-content/60">
                                    <p>{{ $tt('• 将勾选的音乐文件导入音乐收藏库') }}</p>
                                    <p>{{ $tt('• 支持批量导入和智能去重') }}</p>
                                    <p>{{ $tt('• 导入速率可调节，适应不同性能的机器') }}</p>
                                </div>
                            </div>
                        </div>

                        <!-- 导入设置分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-base-content/20 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('导入设置') }}</h3>
                                <div class="badge badge-ghost badge-sm">{{ $tt('参数配置') }}</div>
                            </div>
                            <div class="ml-4 pl-3 border-l border-base-200 space-y-3">
                                <!-- 跳过已入库文件 -->
                                <div class="form-control">
                                    <label class="label cursor-pointer justify-start space-x-3 py-2">
                                        <input type="checkbox" class="toggle toggle-primary" v-model="isSkipExist" />
                                        <div class="flex-1">
                                            <span class="label-text font-medium">{{ $tt('跳过已入库文件') }}</span>
                                            <div class="text-xs text-base-content/60 mt-1">{{ $tt('自动跳过已经存在于收藏库中的音乐文件') }}</div>
                                        </div>
                                    </label>
                                </div>

                                <!-- 导入速率 -->
                                <div class="form-control">
                                    <label class="label cursor-pointer justify-start space-x-3 py-2">
                                        <div class="flex-1">
                                            <span class="label-text font-medium">{{ $tt('导入速率') }}</span>
                                            <div class="text-xs text-base-content/60 mt-1">{{ $tt('每秒导入的音乐文件数量') }}</div>
                                        </div>
                                    </label>
                                    <div class="flex items-center space-x-3">
                                        <input type="number" placeholder="10" min="1" max="100"
                                            class="input input-bordered input-sm w-32 font-mono"
                                            v-model="importRate" />
                                        <span class="text-sm text-base-content/60">{{ $tt('文件/秒') }}</span>
                                    </div>
                                    <div class="text-xs text-base-content/50 mt-2">{{ $tt('建议根据机器性能调节，数值过大可能影响系统稳定性') }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 格式转换 Drawer -->
        <div class="drawer">
            <input id="change-format" type="checkbox" class="drawer-toggle" v-model="formatMusicCheckBox" />
            <div class="drawer-side z-50">
                <div @click="formatMusicCheckBox = false" aria-label="close sidebar" class="drawer-overlay"></div>
                <div class="min-h-full bg-base-100 text-base-content w-full md:w-96 pb-20 md:pb-4 flex flex-col">
                    <!-- 标准头部 -->
                    <div class="flex items-center justify-between p-4 border-b border-base-200">
                        <div class="text-xl font-medium">{{ $tt('格式转换') }}</div>
                        <div>
                            <button class="btn btn-sm btn-neutral" @click="formatMusicFunc">{{ $tt('确认') }}</button>
                            <button class="btn btn-sm ml-1" @click="formatMusicCheckBox = false">{{ $tt('取消') }}</button>
                        </div>
                    </div>
                    
                    <!-- 内容区域 -->
                    <div class="flex-1 p-4 space-y-6 overflow-y-auto">
                        <!-- 功能说明分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-primary/40 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('功能说明') }}</h3>
                                <div class="badge badge-primary badge-outline badge-sm">{{ $tt('音频处理') }}</div>
                            </div>
                            <div class="ml-4 pl-3 border-l border-base-200">
                                <div class="space-y-2 text-sm text-base-content/60">
                                    <p>{{ $tt('• 将音频转换成其他格式，保存在同目录下') }}</p>
                                    <p>{{ $tt('• 不会删除源文件，安全可靠') }}</p>
                                    <p>{{ $tt('• 需要下载') }} <a href="https://johnvansickle.com/ffmpeg/" target="_blank" class="text-primary hover:underline">ffmpeg</a> {{ $tt('可执行文件') }}</p>
                                    <p>{{ $tt('• 放置在挂载的 /app/data/bin/ 目录下') }}</p>
                                </div>
                            </div>
                        </div>

                        <!-- 输入设置分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-info/40 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('输入设置') }}</h3>
                                <div class="badge badge-info badge-outline badge-sm">{{ $tt('源文件') }}</div>
                            </div>
                            <div class="ml-4 pl-3 border-l border-base-200 space-y-3">
                                <!-- 输入格式 -->
                                <div class="form-control">
                                    <label class="label cursor-pointer justify-start space-x-3 py-2">
                                        <div class="flex-1">
                                            <span class="label-text font-medium">{{ $tt('输入格式') }}</span>
                                            <div class="text-xs text-base-content/60 mt-1">{{ $tt('选择需要转换的音频格式') }}</div>
                                        </div>
                                    </label>
                                    <MultiSelect
                                        v-model="selectInputFormats"
                                        :options="inputFormatList"
                                        :placeholder="$tt('留空则转换所有格式')"
                                    />
                                    <div class="text-xs text-base-content/50 mt-2">{{ $tt('留空则对所有格式进行转换') }}</div>
                                </div>
                            </div>
                        </div>

                        <!-- 格式设置分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-base-content/20 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('格式设置') }}</h3>
                                <div class="badge badge-ghost badge-sm">{{ $tt('输出配置') }}</div>
                            </div>
                            <div class="ml-4 pl-3 border-l border-base-200 space-y-3">
                                <!-- 目标格式 -->
                                <div class="form-control">
                                    <label class="label cursor-pointer justify-start space-x-3 py-2">
                                        <div class="flex-1">
                                            <span class="label-text font-medium">{{ $tt('目标格式') }}</span>
                                            <div class="text-xs text-base-content/60 mt-1">{{ $tt('选择音频输出格式') }}</div>
                                        </div>
                                    </label>
                                    <select class="select select-bordered select-sm w-full" v-model="selectFormat">
                                        <option v-for="option in formatList" :key="'format' + option.id" :id="option.id"
                                            :name="option.name" :value="option.id">
                                            {{ $tt(option.name) }}
                                        </option>
                                    </select>
                                </div>

                                <!-- 比特率 -->
                                <div class="form-control">
                                    <label class="label cursor-pointer justify-start space-x-3 py-2">
                                        <div class="flex-1">
                                            <span class="label-text font-medium">{{ $tt('比特率') }}</span>
                                            <div class="text-xs text-base-content/60 mt-1">{{ $tt('音频质量设置') }}</div>
                                        </div>
                                    </label>
                                    <select class="select select-bordered select-sm w-full" v-model="selectBitRate">
                                        <option v-for="option in bitRateList" :key="'bitrate' + option.id" :id="option.id"
                                            :name="option.name" :value="option.id">
                                            {{ $tt(option.name) }}
                                        </option>
                                    </select>
                                    <div v-if="selectBitRate === 'custom'" class="mt-3">
                                        <div class="flex items-center space-x-3">
                                            <input type="number" placeholder="128" min="1" max="1000"
                                                class="input input-bordered input-sm w-32 font-mono"
                                                v-model="selectBitRateCustom" />
                                            <span class="text-sm text-base-content/60">kbps</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- 采样率 -->
                                <div class="form-control">
                                    <label class="label cursor-pointer justify-start space-x-3 py-2">
                                        <div class="flex-1">
                                            <span class="label-text font-medium">{{ $tt('采样率') }}</span>
                                            <div class="text-xs text-base-content/60 mt-1">{{ $tt('音频采样频率') }}</div>
                                        </div>
                                    </label>
                                    <select class="select select-bordered select-sm w-full" v-model="selectSampleRate">
                                        <option v-for="option in sampleRateList" :key="'samplerate' + option.id" :id="option.id"
                                            :name="option.name" :value="option.id">
                                            {{ $tt(option.name) }}
                                        </option>
                                    </select>
                                    <div v-if="selectSampleRate === 'custom'" class="mt-3">
                                        <div class="flex items-center space-x-3">
                                            <input type="number" placeholder="44100" min="1" max="192000"
                                                class="input input-bordered input-sm w-32 font-mono"
                                                v-model="selectSampleRateCustom" />
                                            <span class="text-sm text-base-content/60">Hz</span>
                                        </div>
                                        <p class="text-xs text-base-content/50 mt-2">{{ $tt('必须是目标格式支持的有效采样率值，否则将转换失败') }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 分割音轨 Drawer -->
        <div class="drawer">
            <input id="split_cue" type="checkbox" class="drawer-toggle" v-model="splitCueCheckBox" />
            <div class="drawer-side z-50">
                <div @click="splitCueCheckBox = false" aria-label="close sidebar" class="drawer-overlay"></div>
                <div class="min-h-full bg-base-100 text-base-content w-full md:w-96 pb-20 md:pb-4 flex flex-col">
                    <!-- 标准头部 -->
                    <div class="flex items-center justify-between p-4 border-b border-base-200">
                        <div class="text-xl font-medium">{{ $tt('分割音轨') }}</div>
                        <div>
                            <button class="btn btn-sm btn-neutral" @click="splitCueFunc">{{ $tt('确认') }}</button>
                            <button class="btn btn-sm ml-1" @click="splitCueCheckBox = false">{{ $tt('取消') }}</button>
                        </div>
                    </div>
                    
                    <!-- 内容区域 -->
                    <div class="flex-1 p-4 space-y-6 overflow-y-auto">
                        <!-- 功能说明分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-warning/40 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('功能说明') }}</h3>
                                <div class="badge badge-warning badge-outline badge-sm">{{ $tt('音频切割') }}</div>
                            </div>
                            <div class="ml-4 pl-3 border-l border-base-200">
                                <div class="space-y-2 text-sm text-base-content/60">
                                    <p>{{ $tt('• 使用 CUE 标记文件无损切割整轨 CD 音轨') }}</p>
                                    <p>{{ $tt('• 不会删除源文件（除非手动选择）') }}</p>
                                    <p>{{ $tt('• 需要下载') }} <a href="https://johnvansickle.com/ffmpeg/" target="_blank" class="text-primary hover:underline">ffmpeg</a> {{ $tt('可执行文件') }}</p>
                                    <p>{{ $tt('• 放置在挂载的 /app/data/bin/ 目录下') }}</p>
                                </div>
                            </div>
                        </div>

                        <!-- 输出设置分组 -->
                        <div class="space-y-4">
                            <div class="flex items-center space-x-3">
                                <div class="w-1 h-5 bg-base-content/20 rounded-full"></div>
                                <h3 class="text-lg font-semibold text-base-content">{{ $tt('输出设置') }}</h3>
                                <div class="badge badge-ghost badge-sm">{{ $tt('文件格式') }}</div>
                            </div>
                            <div class="ml-4 pl-3 border-l border-base-200 space-y-3">
                                <!-- 目标格式 -->
                                <div class="form-control">
                                    <label class="label cursor-pointer justify-start space-x-3 py-2">
                                        <div class="flex-1">
                                            <span class="label-text font-medium">{{ $tt('目标格式') }}</span>
                                            <div class="text-xs text-base-content/60 mt-1">{{ $tt('选择切割后的音频格式') }}</div>
                                        </div>
                                    </label>
                                    <select class="select select-bordered select-sm w-full" v-model="selectCueFormat">
                                        <option v-for="option in formatList2" :key="'cueformat' + option.id" :id="option.id"
                                            :name="option.name" :value="option.id">
                                            {{ $tt(option.name) }}
                                        </option>
                                    </select>
                                </div>

                                <!-- 删除源文件选项 -->
                                <div class="form-control">
                                    <label class="label cursor-pointer justify-start space-x-3 py-2">
                                        <input type="checkbox" class="toggle toggle-warning" v-model="isDeleteSource" />
                                        <div class="flex-1">
                                            <span class="label-text font-medium">{{ $tt('删除源文件') }}</span>
                                            <div class="text-xs text-base-content/60 mt-1">{{ $tt('切割完成后是否删除原始文件') }}</div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue';
import MultiSelect from "@/components/iview/MultiSelect";

export default {
    name: 'MediaProcessor',
    components: { SvgIcon, MultiSelect },
    props: {
        detail: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        checkedData: {
            type: Array,
            default: () => []
        },
        filePath: {
            type: String,
            default: ''
        },
        userRole: {
            type: String,
            default: ''
        },
        cardMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectFormat: '',
            selectCueFormat: '',
            isDeleteSource: false,
            selectInputFormats: [],
            inputFormatList: [
                { id: 'flac', name: 'FLAC' },
                { id: 'mp3', name: 'MP3' },
                { id: 'ape', name: 'APE' },
                { id: 'wav', name: 'WAV' },
                { id: 'aiff', name: 'AIFF' },
                { id: 'aif', name: 'AIF' },
                { id: 'tta', name: 'TTA' },
                { id: 'm4a', name: 'M4A' },
                { id: 'ogg', name: 'OGG' },
                { id: 'opus', name: 'OPUS' },
                { id: 'wma', name: 'WMA' },
                { id: 'dsf', name: 'DSF' },
                { id: 'dff', name: 'DFF' },
                { id: 'wmv', name: 'WMV' },
                { id: 'dts', name: 'DTS' },
                { id: 'aac', name: 'AAC' }
            ],
            formatList: [
                { id: '', name: '维持原格式' },
                { id: 'mp3', name: 'MP3' },
                { id: 'wav', name: 'WAV' },
                { id: 'flac', name: 'FLAC' },
                { id: 'wma', name: 'WMA' },
                { id: 'ogg', name: 'OGG' }
            ],
            formatList2: [
                { id: '', name: '维持原格式' },
                { id: 'mp3', name: 'MP3' },
                { id: 'wav', name: 'WAV' },
                { id: 'flac', name: 'FLAC' },
                { id: 'wma', name: 'WMA' },
                { id: 'ogg', name: 'OGG' }
            ],
            selectBitRate: '-1',
            selectBitRateCustom: '',
            bitRateList: [
                { id: '-1', name: '保持原样' },
                { id: '32', name: '32k' },
                { id: '64', name: '64k' },
                { id: '96', name: '96k' },
                { id: '128', name: '128k' },
                { id: '160', name: '160k' },
                { id: '192', name: '192k' },
                { id: '224', name: '224k' },
                { id: '256', name: '256k' },
                { id: '320', name: '320k' },
                { id: 'custom', name: '自定义' }
            ],
            selectSampleRate: '-1',
            selectSampleRateCustom: '',
            sampleRateList: [
                { id: '-1', name: '保持原样' },
                { id: '11025', name: '11025' },
                { id: '22050', name: '22050' },
                { id: '44100', name: '44100' },
                { id: '48000', name: '48000' },
                { id: 'custom', name: '自定义' }
            ],
            isKeepSource: true,
            isSign: false,
            saveDir: '',
            isAcoustid: false,
            isMetadataCompare: false,
            isSkipExist: true,
            importRate: 10,
            splitCueCheckBox: false,
            formatMusicCheckBox: false,
            importMusicCheckBox: false,
            gainCheckBox: false,
            generateStrmCheckBox: false,
            duplicateCheckBox: false
        }
    },
    methods: {
        formatMusicFunc() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: this.$tt('发生提示'),
                    content: this.$tt('请先勾选文件或文件夹！'),
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')

            this.$api.Task.formatMusic({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'music_type': this.selectFormat,
                'bit_rate': this.selectBitRate,
                'bit_rate_custom': this.selectBitRateCustom,
                'sample_rate': this.selectSampleRate,
                'sample_rate_custom': this.selectSampleRateCustom,
                'is_keep_source': this.isKeepSource,
                'input_formats': this.selectInputFormats
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.$myMsg.notify({
                        title: this.$tt('创建成功！'),
                        content: this.$tt('任务在后台努力运行中'),
                        type: 'success',
                        time: 2000,
                    })
                    this.$parent.handleSearchFile && this.$parent.handleSearchFile()
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: res.message.data.message ? res.message.data.message: this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },

        splitCueFunc() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: this.$tt('发生提示'),
                    content: this.$tt('请先勾选文件或文件夹！'),
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')

            this.$api.Task.splitCueMusic({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'is_delete_source': this.isDeleteSource,
                'target_format': this.selectCueFormat
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.$myMsg.notify({
                        title: this.$tt('创建成功！'),
                        content: this.$tt('任务在后台努力运行中'),
                        type: 'success',
                        time: 2000,
                    })
                    this.$parent.handleSearchFile && this.$parent.handleSearchFile()
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: res.message.data.message ? res.message.data.message: this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },

        importMusic() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: this.$tt('发生提示'),
                    content: this.$tt('请先勾选文件或文件夹！'),
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')

            this.$api.Task.importMusicIn({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'music_info': {},
                'is_skip_exist': this.isSkipExist,
                'import_rate': this.importRate
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.$myMsg.notify({
                        title: this.$tt('创建成功！'),
                        content: this.$tt('任务在后台努力运行中'),
                        type: 'success',
                        time: 2000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: res.message.data.message ? res.message.data.message: this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },

        checkForDuplicates() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: this.$tt('发生提示'),
                    content: this.$tt('请先勾选文件或文件夹！'),
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.duplicateCheckBox = false;
            this.$emit('loading-start')

            this.$api.Task.checkDuplicate({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'is_acoustid': this.isAcoustid,
                'is_metadata_compare': this.isMetadataCompare
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.$myMsg.notify({
                        title: this.$tt('创建成功！'),
                        content: this.$tt('任务在后台努力运行中'),
                        type: 'success',
                        time: 2000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: res.message.data.message ? res.message.data.message: this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },

        handleReplayGain() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: this.$tt('发生提示'),
                    content: this.$tt('请先勾选文件或文件夹！'),
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')

            this.$api.Task.batchUpdateId3({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'music_info': {},
                'is_regainer': true
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.$myMsg.notify({
                        title: this.$tt('创建成功！'),
                        content: this.$tt('任务在后台努力运行中'),
                        type: 'success',
                        time: 2000,
                        url: '/#/log'
                    });
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: res.message.data.message ? res.message.data.message: this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },

        generateStrmModal() {
            if (this.saveDir === '') {
                this.saveDir = this.filePath
            }
            this.generateStrmCheckBox = true
        },

        generateStrm() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: this.$tt('发生提示'),
                    content: this.$tt('请先勾选文件或文件夹！'),
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')

            this.$api.Task.generateStrm({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'is_sign': this.isSign,
                'save_dir': this.saveDir
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.$myMsg.notify({
                        title: this.$tt('创建成功！'),
                        content: this.$tt('任务在后台努力运行中'),
                        type: 'success',
                        time: 2000,
                    })
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: res.message.data.message ? res.message.data.message: this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        }
    }
}
</script>

<style scoped>
.icon {
    @apply fill-current w-16;
}
</style>
